"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Asset = void 0;
var _react = _interopRequireDefault(require("react"));
var _ActionLink = require("b2b-components/theme/components/ActionLink");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Asset.scss");
const Asset = _ref => {
  let {
    className,
    text,
    thumbnail,
    fileName,
    url,
    onClick
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-cms-Asset-Wrapper', className);
  const handleClick = e => {
    e.preventDefault();
    onClick?.(url);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-Asset"
  }, !!thumbnail && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-Asset-ImageWrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: fileName,
    className: "cds-cms-Asset-Image",
    src: thumbnail
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-Asset-ContentWrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-cms-Asset-FileName"
  }, fileName), /*#__PURE__*/_react.default.createElement(_ActionLink.ActionLink, {
    iconName: _ActionLink.ACTION_LINK_ICON_NAME.download,
    iconSize: _ActionLink.ACTION_LINK_ICON_SIZE.small,
    onClick: handleClick
  }, text.download))));
};
exports.Asset = Asset;
//# sourceMappingURL=Asset.js.map